import { render, staticRenderFns } from "./modal_commission.vue?vue&type=template&id=3d61b8c0"
import script from "./modal_commission.vue?vue&type=script&lang=js"
export * from "./modal_commission.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports